// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.position-management {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Header */
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: 12px;
  flex: 1 1;
}

.btn-create {
  padding: 10px 24px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-create:hover {
  background: #059669;
}

/* Category Sections */
.category-section {
  margin-bottom: 32px;
}

.category-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.category-title .count {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  margin-left: 8px;
}

/* Positions Grid */
.positions-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.position-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
}

.position-card:hover {
  border-color: #2563eb;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.position-card.inactive {
  opacity: 0.6;
  background: #f9fafb;
}

.position-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.position-title h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 4px 0;
}

.position-en {
  font-size: 13px;
  color: #6b7280;
  font-weight: 400;
}

.position-count {
  background: #eff6ff;
  color: #1e40af;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.position-description {
  font-size: 14px;
  color: #4b5563;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.position-requirements {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 12px;
  padding: 8px;
  background: #f9fafb;
  border-radius: 4px;
}

.position-requirements strong {
  color: #374151;
  margin-right: 4px;
}

.position-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.status-badge {
  font-size: 12px;
}

.badge-active {
  color: #10b981;
  font-weight: 500;
}

.badge-inactive {
  color: #ef4444;
  font-weight: 500;
}

.position-actions {
  display: flex;
  gap: 8px;
}

.position-actions button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-toggle {
  background: #f3f4f6;
  color: #374151;
}

.btn-toggle:hover {
  background: #e5e7eb;
}

.btn-edit {
  background: #dbeafe;
  color: #1e40af;
}

.btn-edit:hover {
  background: #bfdbfe;
}

.btn-delete {
  background: #fee2e2;
  color: #dc2626;
}

.btn-delete:hover {
  background: #fecaca;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-state p {
  font-size: 16px;
  color: #6b7280;
  margin: 0 0 24px 0;
}

/* Responsive */
@media (max-width: 768px) {
  .position-management {
    padding: 16px;
  }

  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .filters {
    flex-direction: column;
  }

  .positions-list {
    grid-template-columns: 1fr;
  }

  .position-footer {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .position-actions {
    justify-content: space-between;
  }

  .position-actions button {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServePositions/PositionManagement.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":[".position-management {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Header */\n.header-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.filters {\n  display: flex;\n  gap: 12px;\n  flex: 1;\n}\n\n.btn-create {\n  padding: 10px 24px;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.btn-create:hover {\n  background: #059669;\n}\n\n/* Category Sections */\n.category-section {\n  margin-bottom: 32px;\n}\n\n.category-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.category-title .count {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 400;\n  margin-left: 8px;\n}\n\n/* Positions Grid */\n.positions-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.position-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  transition: all 0.2s;\n}\n\n.position-card:hover {\n  border-color: #2563eb;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.position-card.inactive {\n  opacity: 0.6;\n  background: #f9fafb;\n}\n\n.position-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.position-title h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 4px 0;\n}\n\n.position-en {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.position-count {\n  background: #eff6ff;\n  color: #1e40af;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.position-description {\n  font-size: 14px;\n  color: #4b5563;\n  margin: 0 0 12px 0;\n  line-height: 1.5;\n}\n\n.position-requirements {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 12px;\n  padding: 8px;\n  background: #f9fafb;\n  border-radius: 4px;\n}\n\n.position-requirements strong {\n  color: #374151;\n  margin-right: 4px;\n}\n\n.position-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.status-badge {\n  font-size: 12px;\n}\n\n.badge-active {\n  color: #10b981;\n  font-weight: 500;\n}\n\n.badge-inactive {\n  color: #ef4444;\n  font-weight: 500;\n}\n\n.position-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.position-actions button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-toggle {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.btn-toggle:hover {\n  background: #e5e7eb;\n}\n\n.btn-edit {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.btn-edit:hover {\n  background: #bfdbfe;\n}\n\n.btn-delete {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.btn-delete:hover {\n  background: #fecaca;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.empty-state p {\n  font-size: 16px;\n  color: #6b7280;\n  margin: 0 0 24px 0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .position-management {\n    padding: 16px;\n  }\n\n  .header-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filters {\n    flex-direction: column;\n  }\n\n  .positions-list {\n    grid-template-columns: 1fr;\n  }\n\n  .position-footer {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .position-actions {\n    justify-content: space-between;\n  }\n\n  .position-actions button {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
